export const FORECASTING_AC_LINE_LOSS_REQUEST = "FORECASTING_AC_LINE_LOSS_REQUEST";
export const FORECASTING_AC_LINE_LOSS_SUCCESS = "FORECASTING_AC_LINE_LOSS_SUCCESS";
export const FORECASTING_AC_LINE_LOSS_FAIL = "FORECASTING_AC_LINE_LOSS_FAIL";
export const FORECASTING_AC_LINE_LOSS_RESET = "FORECASTING_AC_LINE_LOSS_RESET";

export const FORECASTING_PR_REQUEST = "FORECASTING_PR_REQUEST";
export const FORECASTING_PR_SUCCESS = "FORECASTING_PR_SUCCESS";
export const FORECASTING_PR_FAIL = "FORECASTING_PR_FAIL";
export const FORECASTING_PR_RESET = "FORECASTING_PR_RESET";

export const FORECASTING_SCBSMBSTRING_DEVIATION_REQUEST = "FORECASTING_SCBSMBSTRING_DEVIATION_REQUEST";
export const FORECASTING_SCBSMBSTRING_DEVIATION_SUCCESS = "FORECASTING_SCBSMBSTRING_DEVIATION_SUCCESS";
export const FORECASTING_SCBSMBSTRING_DEVIATION_FAIL = "FORECASTING_SCBSMBSTRING_DEVIATION_FAIL";
export const FORECASTING_SCBSMBSTRING_DEVIATION_RESET = "FORECASTING_SCBSMBSTRING_DEVIATION_RESET";


export const FORECASTING_PLANT_AVAILABILITY_REQUEST = "FORECASTING_PLANT_AVAILABILITY_REQUEST";
export const FORECASTING_PLANT_AVAILABILITY_SUCCESS = "FORECASTING_PLANT_AVAILABILITY_SUCCESS";
export const FORECASTING_PLANT_AVAILABILITY_FAIL = "FORECASTING_PLANT_AVAILABILITY_FAIL";
export const FORECASTING_PLANT_AVAILABILITY_RESET = "FORECASTING_PLANT_AVAILABILITY_RESET";


export const FORECASTING_PLANT_AVAILABILITY_REQUEST2 = "FORECASTING_PLANT_AVAILABILITY_REQUEST2";
export const FORECASTING_PLANT_AVAILABILITY_SUCCESS2 = "FORECASTING_PLANT_AVAILABILITY_SUCCESS2";
export const FORECASTING_PLANT_AVAILABILITY_FAIL2 = "FORECASTING_PLANT_AVAILABILITY_FAIL2";
export const FORECASTING_PLANT_AVAILABILITY_RESET2 = "FORECASTING_PLANT_AVAILABILITY_RESET2";


export const FORECASTING_SOILING_LOSS_REQUEST = "FORECASTING_SOILING_LOSS_REQUEST";
export const FORECASTING_SOILING_LOSS_SUCCESS = "FORECASTING_SOILING_LOSS_SUCCESS";
export const FORECASTING_SOILING_LOSS_FAIL = "FORECASTING_SOILING_LOSS_FAIL";
export const FORECASTING_SOILING_LOSS_RESET = "FORECASTING_SOILING_LOSS_RESET";


export const FORECASTING_TRANSFORMER_TEMPERATURE_REQUEST = "FORECASTING_TRANSFORMER_TEMPERATURE_REQUEST";
export const FORECASTING_TRANSFORMER_TEMPERATURE_SUCCESS = "FORECASTING_TRANSFORMER_TEMPERATURE_SUCCESS";
export const FORECASTING_TRANSFORMER_TEMPERATURE_FAIL = "FORECASTING_TRANSFORMER_TEMPERATURE_FAIL";
export const FORECASTING_TRANSFORMER_TEMPERATURE_RESET = "FORECASTING_TRANSFORMER_TEMPERATURE_RESET";


export const FORECASTING_CABEL_INSULATION_WEAKENING_REQUEST = "FORECASTING_CABEL_INSULATION_WEAKENING_REQUEST";
export const FORECASTING_CABEL_INSULATION_WEAKENING_SUCCESS = "FORECASTING_CABEL_INSULATION_WEAKENING_SUCCESS";
export const FORECASTING_CABEL_INSULATION_WEAKENING_FAIL = "FORECASTING_CABEL_INSULATION_WEAKENING_FAIL";
export const FORECASTING_CABEL_INSULATION_WEAKENING_RESET = "FORECASTING_CABEL_INSULATION_WEAKENING_RESET";


export const FORECASTING_AC_CABEL_INSULATION_WEAKENING_REQUEST = "FORECASTING_AC_CABEL_INSULATION_WEAKENING_REQUEST";
export const FORECASTING_AC_CABEL_INSULATION_WEAKENING_SUCCESS = "FORECASTING_AC_CABEL_INSULATION_WEAKENING_SUCCESS";
export const FORECASTING_AC_CABEL_INSULATION_WEAKENING_FAIL = "FORECASTING_AC_CABEL_INSULATION_WEAKENING_FAIL";
export const FORECASTING_AC_CABEL_INSULATION_WEAKENING_RESET = "FORECASTING_AC_CABEL_INSULATION_WEAKENING_RESET";

export const FORECASTING_CONNECTOR_BOX_HEATING_REQUEST = "FORECASTING_CONNECTOR_BOX_HEATING_REQUEST";
export const FORECASTING_CONNECTOR_BOX_HEATING_SUCCESS = "FORECASTING_CONNECTOR_BOX_HEATING_SUCCESS";
export const FORECASTING_CONNECTOR_BOX_HEATING_FAIL = "FORECASTING_CONNECTOR_BOX_HEATING_FAIL";
export const FORECASTING_CONNECTOR_BOX_HEATING_RESET = "FORECASTING_CONNECTOR_BOX_HEATING_RESET";


export const FORECASTING_GALVANISATION_THICKNESS_REQUEST = "FORECASTING_GALVANISATION_THICKNESS_REQUEST";
export const FORECASTING_GALVANISATION_THICKNESS_SUCCESS = "FORECASTING_GALVANISATION_THICKNESS_SUCCESS";
export const FORECASTING_GALVANISATION_THICKNESS_FAIL = "FORECASTING_GALVANISATION_THICKNESS_FAIL";
export const FORECASTING_GALVANISATION_THICKNESS_RESET = "FORECASTING_GALVANISATION_THICKNESS_RESET";


export const FORECASTING_MODULE_HOTSPOT_REQUEST = "FORECASTING_MODULE_HOTSPOT_REQUEST";
export const FORECASTING_MODULE_HOTSPOT_SUCCESS = "FORECASTING_MODULE_HOTSPOT_SUCCESS";
export const FORECASTING_MODULE_HOTSPOT_FAIL = "FORECASTING_MODULE_HOTSPOT_FAIL";
export const FORECASTING_MODULE_HOTSPOT_RESET = "FORECASTING_MODULE_HOTSPOT_RESET";


export const FORECASTING_MODULE_DEGRADATION_REQUEST = "FORECASTING_MODULE_DEGRADATION_REQUEST";
export const FORECASTING_MODULE_DEGRADATION_SUCCESS = "FORECASTING_MODULE_DEGRADATION_SUCCESS";
export const FORECASTING_MODULE_DEGRADATION_FAIL = "FORECASTING_MODULE_DEGRADATION_FAIL";
export const FORECASTING_MODULE_DEGRADATION_RESET = "FORECASTING_MODULE_DEGRADATION_RESET";